import _ from "lodash";
import {
  getRequest,
  postRequest,
  patchRequest,
  deleteRequest,
} from "NetworkCall";
import { INSTANCE_URL, itemCount } from "Constants";

export var FORM_BUILDER_MODAL = "FORM_BUILDER_MODAL";
export var FORM_BUILDER_FORM_LIST = "FORM_BUILDER_FORM_LIST";
export var FORM_BUILDER_FORM_NAME = "FORM_BUILDER_FORM_NAME";
export var FORM_BUILDER_SAVED_LIST = "FORM_BUILDER_SAVED_LIST";
export var FORM_BUILDER_TOTAL_SAVED_LIST = "FORM_BUILDER_TOTAL_SAVED_LIST";
export var FORM_CHANGED_FOR_UPDATE = "FORM_CHANGED_FOR_UPDATE";

export function dynamicFormModal(obj) {
  return (dispatch) => {
    dispatch({ type: FORM_BUILDER_MODAL, payload: obj });
  };
}

export function updateFormList(newKey, oldKeys, action) {
  let oldRecord = [];

  if (oldKeys.length > 0) {
    oldRecord = oldKeys;
  }

  if (action === "new") {
    oldRecord = newKey;
  }

  if (action === "add") {
    oldRecord.push(newKey);
  } else if (action === "remove") {
    _.remove(oldKeys, {
      id: newKey.id,
    });
  } else if (action === "samearray") {
    oldRecord = newKey;
  }

  return (dispatch) => {
    dispatch({ type: FORM_BUILDER_FORM_LIST, payload: oldRecord });
  };
}

export function updateFomeName(name) {
  return (dispatch) => {
    dispatch({ type: FORM_BUILDER_FORM_NAME, payload: name });
  };
}

export function updateNewFormList(newData, oldKeys) {
  var index = _.findIndex(oldKeys, { id: newData.id });

  // Replace item at index using native splice
  oldKeys.splice(index, 1, {
    ...newData,
    // key: newData.key, required: newData.required, maxlen:newData.maxlen, label: newData.label, id: newData.id,
  });

  return (dispatch) => {
    dispatch({ type: FORM_BUILDER_FORM_LIST, payload: oldKeys });
  };
}

export function fetchFormBuilderMaxVersionWise(session, formid, callback) {
  var filter = encodeURI(`(eventid=${session.eventid})AND(formid=${formid})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event_forms?related=tickets_by_formid&filter=(${filter})&order=createdon%20DESC`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        callback({ success: 1, response: data.resource });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function fetchFormBuilder(session, pageCount = 0, callback) {
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;

  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;
  var postData = {
    limit: itemCount,
    offset: offset,
    event: { eventid: session.eventid },
    type: "fetchFormBuilder",
  };
  return (dispatch) => {
    postRequest(
      url,
      postData,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: FORM_BUILDER_SAVED_LIST,
          payload: { resource: data.response, count: data.count },
        });
        dispatch({
          type: FORM_BUILDER_TOTAL_SAVED_LIST,
          payload: { resource: data.totalForms, count: data.count },
        });
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function saveForm(session, values, callback) {
  // let url = `${INSTANCE_URL}/api/v2/eventify/_table/event_forms`;
  let url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;

  let eventid = session.eventid;
  let createdby = session.userid;
  let updatedby = createdby;
  values = {
    ...values,
    eventid,
    createdby,
    updatedby,
    type: "saveFormBuilder",
  };

  return (dispatch) => {
    postRequest(
      url,
      values,
      session,
      dispatch,
      (response) => {
        callback({ success: 1, data: response });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function formEdited(status, callback) {
  return (dispatch) => {
    dispatch({ type: FORM_CHANGED_FOR_UPDATE, payload: { status: status } });
  };
}

export function markDefault(session, values, callback) {
  let url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;

  let body = {
    formid: values.formid,
    type: "setdefault",
  };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        if (response.success == 1) {
          callback({ success: 1, data: response });
        } else {
          callback({ success: 0, message: response.message });
        }
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}
